export enum TemperatureSensorNameEnum {
    // WARM WATER enums
    WARM_WATER_TEMP_CIRCULATION = 'Warmwasser Zirkulation ',
    WARM_WATER_TEMP_BUFFER = 'Warmwasser Puffer ',
    WARM_WATER_TEMP_BOILER = 'Warmwasser Boiler ',
    WARM_WATER_TEMP_SOLAR = 'Solarspeicher ',
    FRESH_WATER_STATION_PRIMARY = 'Frischwasserstation Primär ',
    WARM_WATER_TEMP_OUTLET = 'Warmwasser Auslass ',
    CUSTOM_WATER = 'Benutzerdefiniertes Warmwasser ',

    // TEMPERATURE enums, all temperature values are number and followed by the 2 endings, meaning they are all pair values
    HEATER_CL = 'Heizkreis ',
    HEATER_BL = 'Kesselkreis ',
    HEATER_BL_SECONDARY = 'Kesselkreis Sekundär ',
    HEATER_DH_PRIMARY = 'Fernwärme Kreis Primär ',
    HEATER_DH_SECONDARY = 'Fernwärme Kreis Sekundär ',
    HEATER_SL_PRIMARY = 'Solarkreis Primär ',
    HEATER_SL_SECONDARY = 'Solarkreis Sekundär ',
    HEATER_BLC = 'Pufferladekreis ',
    HEATER_BLC_SECONDARY = 'Pufferladekreis Sekundär ',
    HEATER_WHLC = 'Boilerladekreis ',
    HEATER_WHLC_SECONDARY = 'Boilerladekreis Sekundär ',
    HEATER_BRINE_LOOP = 'Solekreis ',
    HEATER_HPL = 'Wärmepumpe Kreis ',
    HEATER_LH = 'Nahwärme Kreis ',
    CUSTOM_LOOP = 'Benutzerdefinierter Kreis ',
    COLLECTION_LOOP = 'Hauptsammelkreis ',

    // endings for some numbered enuns
    FLOW_TEMP = ' Vorlauftemperatur',
    RETURN_TEMP = ' Rücklauftemperatur',
    FRESH_WATER_TEMP = ' Warmwasser',
}
